import { render, staticRenderFns } from "./SocialPostSharedItem.vue?vue&type=template&id=4bb4cbde&"
import script from "./SocialPostSharedItem.vue?vue&type=script&lang=js&"
export * from "./SocialPostSharedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports